export const QUERY_KEYS = {
  AUTH_CURRENT_GET: "AUTH_CURRENT_GET",
  AUTH_LOGIN_POST: "AUTH_LOGIN_POST",
  CRUDLS_HTML_TEXT_GET: "CRUDLS_HTML_TEXT_GET",
  CRUDLS_HTML_TEXT_LIST_GET: "CRUDLS_HTML_TEXT_LIST_GET",
  CRUDLS_HTML_TEXT_SEARCH: "CRUDLS_HTML_TEXT_SEARCH",
};
